import { perkFx } from "./perks";
import { ngPlus, type AudienceId, type Era } from "@bd/content";
import { dateOf } from "./calendar";
import type { Company, GameState } from "./state";

/**
 * New Game+: a twisted alternate history, unlocked by finishing a season. Content arrives at different times,
 * hobby players outnumber families, rivals move faster, and the last decade is the secret Automaton Age.
 */

export function isNgPlus(co: Company): boolean {
  return co.flags.includes("ngplus");
}

/** The era for a week, with New Game+'s secret era swapped in. */
export function eraFor(state: GameState, week: number): Era {
  const d = dateOf(week);
  if (state.settings.newGamePlus && d.year >= ngPlus.era.from) return ngPlus.era;
  return d.era;
}

/** Years earlier (negative) or later that an unlock arrives in New Game+. */
export function yearShift(co: Company, unlockId: string): number {
  return isNgPlus(co) ? ngPlus.yearShift[unlockId] ?? 0 : 0;
}

export function audienceMult(co: Company, aud: AudienceId): number {
  const casual = aud === "kids" || aud === "family" || aud === "party" ? 1 + perkFx(co, "casualSales") : aud === "hobby" || aud === "hardcore" || aud === "collectors" ? 1 + perkFx(co, "hobbySales") : aud === "roleplayers" ? 1 + perkFx(co, "storySales") : 1;
  return (isNgPlus(co) ? ngPlus.audienceMult[aud] ?? 1 : 1) * casual;
}
